export class ConfigurationView {
    key?: string | undefined;
    displayValue?: string | undefined;
}